import $ from 'jquery'
import store_fiche from "@/store/mods/consultations/fiche-consultations"

export default {
    name: 'manage-examen-fe',
    components: {},
    props: {
        evolution_id: Number,
        consultation_id: Number,
        user_id: Number,
        info_user: Object,
        group_id: Number,
        grs_toggler: Number,
        selected_exam: Array,
        data_to_be_deleted: Object
    },

    data() {
        return {
            save_loading: false,
            is_loading: true,
            exm_data: {
                v_model: []
            },
            fields: [
                'sein_gauche', 'sein_droit', 'etat_mamelons',
                'uterus_hu', 'uterus_saignement', 'uterus_perte_eaux',
                'abdomen', 'bassin_obstetrical', 'paleur_conjonctive',
                'col_etat', 'col_position', 'col_longueur', 'col_ouverture', 
                'annexe', 'couleur_pertes', 'odeur_pertes'
            ],

            is_error: false,
            permission_is_denied: false,
            del_loading: false,
            is_confirm: false,

            oui_non_datas: [
                'Oui', 'Non'
            ],
            ht_uterine_datas: [
                'Normale', 'Anormale'
            ],
        }
    },

    watch : {
        grs_toggler() {
            this.initFields()
        }
    },

    computed: {
        examen_options() {
            return this.$store.getters["examen_options"]
        },
    },

    mounted() {
        // Get all param cpn options -- refers to examen_options
        this.$store.dispatch('getAllParamCpn')
    },

    methods: {
        initFields() {
            this.is_loading = true
            this.exm_data = {
                v_model: []
            }
            
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.selected_exam.length > 0) {
                    v = this.selected_exam[index]['field_content']
                } 
                
                this.exm_data.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        saveExamenPhysique() {
            this.permission_is_denied = false
            this.is_error = false

            // const champs = this.exm_data.v_model
            // let tmp_champs = []
            // champs.forEach(c => {
            //     const tmp_c = {
            //         field_name: c.field_name,
            //         value: (c.value.libelle)?c.value.libelle:c.value
            //     }
            //     tmp_champs.push(tmp_c)
            // });

            let data = {
                group_id: this.group_id,
                consultation_id: this.consultation_id,
                evolution_id: this.evolution_id,
                user_id: this.user_id,
                user: this.info_user,
                data_type: 'examen_femme_enceinte',
                champs: this.exm_data.v_model
            }

            this.save_loading = true

            store_fiche.saveConsultationFicheSectionData(data).then((response) => {
                if (response.success) {
                    this.$refs.mdl_exm.click()
                    this.$emit('emitRefreshExamenFE')
                    this.successToast(response.message)

                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.mdl_exm.click()
                this.errorToast("Une erreur s'est produite !")
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerGroupExamenFE(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteAntecedent', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Suppression effectuée avec succès !')
                    this.$emit("emitRefreshExamenFE")

                    this.$refs.del_grp_exm.click()
                } else if (response === -2) {
                    this.permission_is_denied = true
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        },
    }
}